// As caixas de informação (.info-box-content) são posicionadas de forma absoluta, com
// deslocamentos fixos definidos em cada tela. Perto das bordas isso as jogava para fora da
// área visível, gerando rolagem horizontal. Aqui elas são reposicionadas para caber na tela:
// o deslocamento original é preservado e apenas complementado com o ajuste necessário.

const MARGEM = 12;

// Limites visíveis: interseção da janela com os ancestrais que recortam o conteúdo.
const areaVisivel = (elemento) => {
  let esquerda = MARGEM;
  let direita = document.documentElement.clientWidth - MARGEM;

  for (let pai = elemento.parentElement; pai && pai !== document.body; pai = pai.parentElement) {
    const estilo = window.getComputedStyle(pai);
    if (estilo.overflowX === 'visible') continue;
    const caixa = pai.getBoundingClientRect();
    esquerda = Math.max(esquerda, caixa.left + MARGEM);
    direita = Math.min(direita, caixa.right - MARGEM);
  }
  return { esquerda, direita };
};

const ajustar = (elemento) => {
  if (elemento.dataset.deslocamentoOriginal === undefined) {
    elemento.dataset.deslocamentoOriginal = elemento.style.transform || '';
  }
  const original = elemento.dataset.deslocamentoOriginal;
  elemento.style.transform = original;

  const caixa = elemento.getBoundingClientRect();
  if (!caixa.width) return;

  const { esquerda, direita } = areaVisivel(elemento);
  let ajuste = 0;
  if (caixa.right > direita) ajuste = direita - caixa.right;
  if (caixa.left + ajuste < esquerda) ajuste = esquerda - caixa.left;

  if (ajuste) elemento.style.transform = `${original} translateX(${ajuste}px)`;
};

const ajustarTodas = () => {
  document.querySelectorAll('.info-box-content').forEach(ajustar);
};

// Observa a montagem das caixas (elas só existem no DOM enquanto abertas) e o redimensionamento.
export function iniciarAjusteDasCaixasInfo() {
  if (typeof window === 'undefined' || window.__ajusteCaixasInfoAtivo) return;
  window.__ajusteCaixasInfoAtivo = true;

  let agendado = false;
  const agendar = () => {
    if (agendado) return;
    agendado = true;
    window.requestAnimationFrame(() => {
      agendado = false;
      ajustarTodas();
    });
  };

  new MutationObserver(agendar).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('resize', agendar);
  agendar();
}

export default iniciarAjusteDasCaixasInfo;
